import { useState, useCallback } from 'react'
import { projectsAPI } from '../services/api'
import { technicalCardAPI } from '../services/api'
import toast from 'react-hot-toast'

export const useProjects = () => {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const uploadTechnicalCard = useCallback(async (file, projectName) => {
    setLoading(true)
    setError(null)

    try {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('project_name', projectName)

      const response = await technicalCardAPI.upload(formData)
      const updatedProjects = [...projects, response.data];
      setProjects(updatedProjects)
      return response.data
    } catch (err) {
      const errorMessage =
        err.response?.data?.detail ||
        err.message ||
        'Ошибка при загрузке технической карты'
      setError(errorMessage)
      throw new Error(errorMessage)
    } finally {
      setLoading(false)
    }
  }, [])

  const createProject = useCallback(async (data) => {
    setLoading(true)
    setError(null)
    try {
      const response = await projectsAPI.create(data)
      return response.data
    } catch (err) {
      setError(err.message)
      toast.error('Ошибка загрузки проектов')
    } finally {
      setLoading(false)
    }
  }, [])

  const analyzeProject = useCallback(async (cardId) => {
    setLoading(true)
    setError(null)
    try {
      const response = await projectsAPI.analyze(cardId)
      return response.data
    } catch (err) {
      setError(err.message)
      toast.error('Ошибка при анализе проекта')
    } finally {
      setLoading(false)
    }
  }, [])

  const fetchProjects = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const response = await projectsAPI.list()
      setProjects(response.data.projects || [])
    } catch (err) {
      setError(err.message)
      toast.error('Ошибка загрузки проектов')
    } finally {
      setLoading(false)
    }
  }, [])

  const getProjectDetails = useCallback(async (cardId) => {
    try {
      const response = await projectsAPI.getDetails(cardId)
      return response.data
    } catch (err) {
      toast.error('Ошибка загрузки деталей проекта')
      throw err
    }
  }, [])
  const deleteProject = useCallback(async (cardId) => {
    try {
      await projectsAPI.delete(cardId)
      setProjects(projects.filter(p => p.id !== cardId))
      toast.success('Проект удален')
    } catch (err) {
      toast.error('Ошибка удаления проекта')
      throw err
    }
  }, [projects])

  const downloadReport = useCallback(async (cardId, fileName) => {
    try {
      const response = await projectsAPI.downloadReport(cardId)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `report_${fileName}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.parentElement.removeChild(link)
      toast.success('Отчет скачан')
    } catch (err) {
      toast.error('Ошибка скачивания отчета')
      throw err
    }
  }, [])

  return {
    projects,
    loading,
    error,
    fetchProjects,
    getProjectDetails,
    analyzeProject,
    uploadTechnicalCard,
    createProject,
    deleteProject,
    downloadReport,
  }
}
